import { useTranslation } from 'react-i18next';
import { SubmitHandler, useForm } from 'react-hook-form';
import {
  ErrorCode,
  openNotification,
  useUpdatePassword,
  handleChangePasswordError,
  UpdatePasswordFormValues,
  useSideOverContext,
} from '@elements-financial/elements';
import { useState } from 'react';

export function useUpdatePasswordForm(onUpdateSucess?: () => void, onUpdateError?: () => void) {
  const { t: tCommon } = useTranslation('common');
  const { t: tForm } = useTranslation('form');

  const { updatePassword } = useUpdatePassword();
  const { closeSideOver } = useSideOverContext();

  const {
    formState: { errors: formErrors },
    register,
    clearErrors,
    handleSubmit,
  } = useForm<UpdatePasswordFormValues>({});

  const [gqlError, setGQLError] = useState<ErrorCode>();

  const onSubmit: SubmitHandler<UpdatePasswordFormValues> = (data) => {
    setGQLError(undefined);

    updatePassword.mutate(
      {
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
      },
      {
        onError: (e) => {
          handleChangePasswordError(e, {
            onInvalidPassword: () => setGQLError(ErrorCode.InvalidPassword),
            onPasswordChangeLimitExceeded: () => setGQLError(ErrorCode.PasswordChangeLimitExceeded),
          });
          onUpdateError?.();
        },
        onSuccess: () => {
          closeSideOver();
          onUpdateSucess?.();
          openNotification({
            description: tForm('password-updated-successfully'),
          });
        },
      }
    );
  };

  const failsNewDifferentThanCurrentPassword = formErrors.newPassword?.type === 'failsNewDifferentThanCurrent';
  const failsComplexity = formErrors.newPassword?.type === 'failsComplexity';
  const failsConfrimedSameAsNewPassword = formErrors.confirmNewPassword;

  const passwordIncorrect = gqlError === ErrorCode.InvalidPassword;
  const passwordChangeLimitExceeded = gqlError === ErrorCode.PasswordChangeLimitExceeded;

  return {
    tCommon,
    tForm,
    formErrors,
    register,
    clearErrors,
    onSubmit,
    loading: updatePassword.isLoading,
    handleSubmit: handleSubmit(onSubmit),
    failsNewDifferentThanCurrentPassword,
    failsComplexity,
    failsConfrimedSameAsNewPassword,
    passwordIncorrect,
    passwordChangeLimitExceeded,
  };
}
